"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.parseUipArrays = exports.getDataFromUipResponse = void 0;
const parseUipArrays = uipArray => {
  if (!Array.isArray(uipArray) || uipArray.length === 0) {
    return [];
  }
  const parsedArray = uipArray.map(x => {
    try {
      return JSON.parse(x);
    } catch {
      return null; // Skip invalid JSON entries
    }
  }).filter(object => object && object.product === 'domain').map(object => object.name);
  return Array.from(new Set(parsedArray.reverse()));
};
exports.parseUipArrays = parseUipArrays;
const getDataFromUipResponse = (uipData = {}) => {
  // Use optional chaining for safe property access
  const uipSearchHistoryArray = uipData?.data?.user?.godaddy?.marketing?.search_history_array || [];
  const uipFavProductArray = uipData?.data?.user?.godaddy?.marketing?.favorite_product_array || [];
  const searchHistoryNoDups = parseUipArrays(uipSearchHistoryArray);
  const favoritesMostRecentFirst = parseUipArrays(uipFavProductArray);

  // Parse favorites data with safe JSON handling
  const favoritesParsedUipData = Array.isArray(uipFavProductArray) ? uipFavProductArray.map(x => {
    try {
      return JSON.parse(x);
    } catch {
      return null;
    }
  }).filter(Boolean) : [];
  return {
    favoritesList: favoritesMostRecentFirst,
    historyList: searchHistoryNoDups,
    favoritesParsedUipData
  };
};
exports.getDataFromUipResponse = getDataFromUipResponse;